import _get from 'lodash/get';
import { formatBytes } from 'src/helpers/helpers';

export const textFormatter = (textField: string) => (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
	return _get(row, textField);
};

export const dateFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
	if (!cell) return;
	const dateString = `${cell}${cell.indexOf('Z') === -1 ? 'Z' : ''}`;
	const timestamp = Date.parse(dateString);
	if (isNaN(timestamp)) return;
	const date = new Date(timestamp);

	const d = [
		`${date.getDate()}`.padStart(2, '0'),
		`${date.getMonth() + 1}`.padStart(2, '0'),
		date.getFullYear(),
	].join('-');
	const t = [`${date.getHours()}`.padStart(2, '0'), `${date.getMinutes()}`.padStart(2, '0')].join(':');
	if (t === '00:00') return d;
	else return `${d} ${t}`;
};

export const fileFormatter = (cell: any, row: any, rowIndex: number, formatExtraData: any) => {
	const { fileName, fileLength } = cell || {};
	if (!fileName) return;
	return `${fileName} (${formatBytes(fileLength)})`;
};
